
import React from "react";
import { useEffect, useState } from 'react';
import cover from '../../assets/images/Rectangle-1-1.png'
import { Link } from 'react-router-dom';

const EducationalAssistanceProgram = () => {


  const [visible, setVisible] = useState(false);

  useEffect(() => {
      const timer = setTimeout(() => {
        setVisible(true);
      }, 500);
      return () => clearTimeout(timer); 
  }, []); 

return (   
      
  <div className="bg-[#fff6ee] text-black px-4 py-8 sm:px-6 lg:px-20">
    

          <div className="background-color">  

        <div className="max-w-4xl mx-auto">   

        <div 
        className="position-relative overflow-hidden w-100" 
        style={{ height: '70vh', maxHeight: '600px' }}
      >
        {/* Background image with overlay */}
        <div 
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            backgroundImage: `url(${cover})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 1
          }}
        >
          <div className="w-100 h-100 bg-black" style={{ opacity: 0.5 }}></div>
        </div>
      
  {/* Centered content */}
  <div 
    className="position-absolute top-50 start-50 translate-middle text-center w-100 px-3"
    style={{
      maxWidth: '960px',
      zIndex: 2,
      transition: 'opacity 1s ease, transform 1s ease',
      transform: visible ? 'translate(-50%, -50%)' : 'translate(-50%, -40%)',
      opacity: visible ? 1 : 0
    }}
  >
    <h1 className="fw-bold text-white mb-4 display-5" style={{textTransform:'uppercase', fontFamily: 'Yanone Kaffeesatz,sans-serif'}}>Educational Assistance Program</h1>
   
  </div>
</div>
    
  </div>
  </div>

  <div className="bg-[#fdf7f0] py-15 px-4 md:px-16 custom-padding">
      <div className="max-w-4xl mx-auto text-center">   
        <p className="text-base md:text-lg text-gray-700 mb-8">
        Gammadda responded to a potential crisis in education caused by skyrocketing prices in stationery items as a result of the economic 
        crisis, by initiating a project to help children in economically disadvantaged areas. This investment in the future and promotion of education is being carried 
        out by providing a complete set of books and stationery items for children from selected schools studying in various grades for the 2023 academic year.
        </p>

        <div className="aspect-w-16 aspect-h-9 mb-10 " style={{ Width: '1000px', height: 'auto' }}>
          <iframe
            className="w-full h-full custome-iframe"
            src="https://www.youtube.com/embed/5FrR1PuuFX0?rel=0&controls=1&autoplay=0&mute=0&start=0" 
            title="Gammadda Thakshalawa"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>        
        </div>

        <div className="text-left space-y-10">
          {/* Ordinary Levels */}
          <div>           
            <p className="text-gray-700 mb-2">
            Due to the low income status of the family, these underprivileged children face even more severe difficulties in 
            accessing their educational necessities. Although a free education may be the right of all Sri Lankans, this comes at a cost. 
            Books, stationery items, uniforms, shoes, access to extracurricular activities all cost money. Not everyone has equal access to these, especially some 
            low income families who have to choose between giving a good education for their children or putting food on the table.
            </p>            
          </div>

          <div class="container my-4">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <img 
                  src="http://cms.gammadda.lk/wp-content/uploads/2025/05/66abaebec6aed14e82f57ce1_Rectangle-128.png" 
                  
                  alt="Image 1" 
                  class="img-fluid rounded shadow-sm w-100"
                  loading="lazy"
                />
              </div>
              <div class="col-12 col-md-6">
                <img 
                  src="http://cms.gammadda.lk/wp-content/uploads/2025/05/66abaebec6aed14e82f57ce3_Rectangle-129.png" 
                  
                  alt="Image 2" 
                  class="img-fluid rounded shadow-sm w-100"
                  loading="lazy"
                />
              </div>
            </div>
        </div>
          
         <div>           
            <p className="text-gray-700 mb-2">
            Furthermore, due to the increases in the price of stationery and food- parents are forced to choose which of their children to send to school. 
            What used to be a once appalling 10% drop-out rate has spiked to 40%. This program nurtures and molds children who are hungry for a good education.
            </p>            
          </div>

          <div class="container mb-4">
            <div class="ratio ratio-16x9" style={{ maxWidth: '1000px', margin: '0 auto' }}>
              <img 
                src="http://cms.gammadda.lk/wp-content/uploads/2025/05/66abaebec6aed14e82f57ce4_333459026_510431651055899_6380524529200728770_n-p-1080.jpg" 
                alt="Gammadda Smiles" 
                class="img-fluid w-100 h-100 object-fit-cover"
              />
            </div>
          </div>

         <div>           
            <p className="text-gray-700 mb-2">
            Our endeavor is to encourage these children and help them achieve great things. Our endeavor is to enable them to dream big dreams.
            </p>            
          </div>

          <div class="container mb-4">
            <div class="ratio ratio-16x9" style={{ maxWidth: '1000px', margin: '0 auto' }}>
              <img 
                src="http://cms.gammadda.lk/wp-content/uploads/2025/05/img-456.jpeg" 
                alt="Gammadda Smiles" 
                class="img-fluid w-100 h-100 object-fit-cover"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
   
  </div>
);

}

export default EducationalAssistanceProgram